import { SelectBox } from "devextreme-react";
import { useEffect, useState } from "react";
import PutPostPatchFetch from "../hooks/PutPostPatchFetch";
import { useAuth } from '../hooks/useAuth';
import { LoadingIndicatorCircle } from "./Loading";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";

const BldgNumberDropDownDevEx = ({ value, setter, isRequired, stylingMode = null }) => {
    const [buildingList, setBuildingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();

    useEffect(() => {
        fetchBuildingNumbers();
    }, [])
    const title = isRequired == true ? "Building Number *" : "Building Number" ;
    const fetchBuildingNumbers = async () => {
        setLoading(true);
        const regionAndUser = { RegionNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], UserId: user.email };
        const bldList = await PutPostPatchFetch('/v1/BuildSpecReport/BuildingNumbersByRegions', 'POST', regionAndUser);
        if (bldList.Success) {
            setBuildingList(bldList.Message);
        }
        else {

            setBuildingList([]);
        }
    }

    const buildingsDataSource = new DataSource({
        store: new ArrayStore({
            data: buildingList,
            key: 'BuildingId',
        }),
        paginate: true,
        pageSize: 10
    })

    const itemRender = (building) => {
        const buildingNumber = building?.SequenceNumber || building || '';
        return (
            <span aria-label={`Building Number ${buildingNumber}`}>
                {buildingNumber}
            </span>
        );
    };

    return (
        <>
            {(loading && !buildingList) && (
                <LoadingIndicatorCircle message="Loading Building Numbers, please wait ..." />
            )}
            <span className="inline__div--wrapper">
                <SelectBox
                    label = {title}
                    labelMode="floating"
                    height={45}
                    value={value}
                    dataSource={buildingsDataSource}
                    displayExpr={'SequenceNumber'}
                    valueExpr={'SequenceNumber'}
                    onValueChanged={(e) => setter(e.value)}
                    isValid = {isRequired == true ? !!value : true}
                    stylingMode={stylingMode}
                    searchEnabled={true}
                    searchExpr={'Select...'}
                    inputAttr={{ 'aria-label': value ? `Building Number ${value}` : 'Building Number' }}
                    itemRender={itemRender}
                />
            </span>
        </>
    )
};

export default BldgNumberDropDownDevEx;